'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Map = function Map(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 72",
    xmlSpace: "preserve",
    height: "24",
    width: '24'
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M60.7,62.6l-8.5-23.1c-0.2-0.6-0.9-1-1.7-1H44c-2.1,5-4.5,9.8-6.8,14.4c-0.2,0.3-0.5,0.6-0.9,0.6\n  \t\ts-0.8-0.2-0.9-0.6c-2.5-4.8-4.8-9.7-6.8-14.4h-5.3c-0.8,0-1.5,0.4-1.7,0.9l-9.8,23.1c-0.1,0.4-0.1,0.7,0.1,1.1\n  \t\tc0.3,0.5,0.9,0.8,1.6,0.8H59c0.7,0,1.2-0.3,1.6-0.7C60.8,63.3,60.8,62.9,60.7,62.6z M40.4,58.9H32v-3.5h8.3V58.9z"
  }), React__default["default"].createElement("path", {
    d: "M46.7,14.3c-2-4-6.1-6.6-10.4-6.6c-0.4,0-0.8,0-1.2,0.1c-4.9,0.5-9.1,4.2-10.2,8.9c-1.1,4.8,1.1,9.8,3,14.1\n  \t\tc0.3,0.7,0.6,1.3,0.9,2c0.2,0.5,0.4,1.1,0.7,1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.1,0.3c2,4.5,4.2,9.2,6.6,13.8\n  \t\tc2.2-4.4,4.5-9.1,6.6-13.8c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.3c1.1-2.5,2.1-5,3-7.6c1-2.8,1.7-5.1,1.7-7.4v-0.2\n  \t\tC47.8,17.4,47.4,15.8,46.7,14.3z M41.8,22.5c-0.9,2.3-3.1,3.9-5.6,3.9c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6\n  \t\tC42.2,21.1,42.1,21.8,41.8,22.5"
  })));
};

var _Map = iconStyles()(Map);

module.exports = _Map;
